import React, { useEffect, useContext, useRef } from 'react'
import { NextpageContext } from '../context/nextpage.context'

export type ICardSliderProps = {
  cardList: any[]
  autoRotate: boolean
}

const CardSlider = ({ cardList, autoRotate }: ICardSliderProps) => {
  const nextpage = useContext(NextpageContext)
  const cardSliderRef = useRef(null)
  const disableAutoRotate = 'disable-auto-rotate'

  useEffect(() => {
    nextpage.UI.components.cardSlider(cardSliderRef.current)
  })

  const cards = cardList.map((cl, i) => (
    <div key={i} className={`card`}>
      {cl}
    </div>
  ))

  return (
    <React.Fragment>
      <div ref={cardSliderRef} className={`col-12 slider cards ${!autoRotate ? disableAutoRotate : ''}`}>
        {cards}
      </div>
    </React.Fragment>
  )
}

export default CardSlider
